import * as  React from 'react';
import * as  _ from 'lodash';
import { ALAN_BTN_SIZE_KEY, DEFAULT_ALAN_BTN_SIZE, TEXT_CHAT_ALAN_BTN_BG_KEY, TEXT_CHAT_ALAN_BTN_LOGO_KEY, getDefaultOptionsValue } from '../../defaultProjectOptions';

const TUTOR_DOMAIN = process.env.TUTOR_DOMAIN;
const DEFAULT_BTN_LOGO = `https://${TUTOR_DOMAIN}/web/src/assets/images/embed/alan_logo.png`;

type NotificationsBtnPreviewProps = {
    btnOptions: any,
    notificationsBubbleFontColor: string
    notificationsBubbleBackgroundColor: string
    platform: string
}

export function NotificationsBtnPreview({
    btnOptions,
    notificationsBubbleFontColor,
    notificationsBubbleBackgroundColor,
    platform
}: NotificationsBtnPreviewProps) {

    const [bg1, bg2] = _.get(btnOptions, TEXT_CHAT_ALAN_BTN_BG_KEY) || getDefaultOptionsValue(platform, TEXT_CHAT_ALAN_BTN_BG_KEY);
    const btnLogo = _.get(btnOptions, TEXT_CHAT_ALAN_BTN_LOGO_KEY) || DEFAULT_BTN_LOGO;
    const btnSize = _.get(btnOptions, ALAN_BTN_SIZE_KEY) || DEFAULT_ALAN_BTN_SIZE;

    return <div className={`notifications-btn-preview`}>
        <div
            className="notifications-btn-preview__alan-btn"
            style={{
                backgroundImage: `linear-gradient(135deg, ${bg1}, ${bg2})`,
                minHeight: `${btnSize}px`,
                maxHeight: `${btnSize}px`,
                height: `${btnSize}px`,
                minWidth: `${btnSize}px`,
                maxWidth: `${btnSize}px`,
                width: `${btnSize}px`,
            }}>
            <img src={btnLogo} />
            <div
                className="alan-btn__chat-notifications-bubble"
                style={{ backgroundColor: notificationsBubbleBackgroundColor, color: notificationsBubbleFontColor }}
            >2</div>
        </div>
    </div>;
}